module.exports = __webpack_public_path__ + "static/media/change_password.79142ae5.png";